import { APP_ERROR_DIAGNOSTICS, type DiagnosticCode } from "./errors-catalog";

export const APP_ERROR_CODES = {
	BAD_REQUEST: 400,
	UNAUTHORIZED: 401,
	FORBIDDEN: 403,
	NOT_FOUND: 404,
	CONFLICT: 409,
	VALIDATION: 422,
	INTERNAL: 500
} as const;

export type AppErrorCode = keyof typeof APP_ERROR_CODES;

export type RetryableAppErrorData = Record<string, unknown> & {
	retryable: true;
};

export class AppError extends Error {
	public readonly statusCode: number;
	public readonly data?: Record<string, unknown>;

	constructor(
		public readonly code: AppErrorCode,
		message: string,
		data?: Record<string, unknown>,
		public readonly diagnosticCode: DiagnosticCode = APP_ERROR_DIAGNOSTICS[code]
	) {
		super(message);
		this.name = "AppError";
		this.statusCode = APP_ERROR_CODES[code];
		this.data = data;
	}
}

export function isErrorWithStatus(error: unknown): error is { status: number; message: string } {
	return (
		typeof error === "object" &&
		error !== null &&
		"status" in error &&
		typeof error.status === "number" &&
		"message" in error &&
		typeof error.message === "string"
	);
}

export function isRetryableConflict(
	e: unknown
): e is AppError & { code: "CONFLICT"; data: RetryableAppErrorData } {
	return (
		e instanceof Error &&
		e.name === "AppError" &&
		(e as Partial<AppError>).code === "CONFLICT" &&
		(e as Partial<AppError>).data?.retryable === true
	);
}
